import { combineReducers } from "redux";
import game from "./game";
import scores from "./scores";
import patterns from "./patterns";
import patterns2d from "./patterns2d";
import clickSequence from "./clickSequence";
import scene from "./scene";
// import fx from "./fx";
import explosions from "./explosions";

const rageReducers = combineReducers({
	patterns,
	patterns2d,
	scores,
	game,
	scene,
	// fx,
    explosions,
    clickSequence
});
export default rageReducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js